import { Injectable, inject } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable } from "rxjs";
import { CstLanguageService } from "../services/cst-language.service";

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private _langService = inject(CstLanguageService);


  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const langIso = this._langService.currentAppLanguage;
    const modifiedRequest = request.clone({
      setHeaders: {
        "Accept-Language": langIso,
      },
    });
    return next.handle(modifiedRequest);
  }
}
